import { render, staticRenderFns } from "./VSubmitButton.vue?vue&type=template&id=469bca78&scoped=true&"
import script from "./VSubmitButton.vue?vue&type=script&lang=js&"
export * from "./VSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./VSubmitButton.vue?vue&type=style&index=0&id=469bca78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469bca78",
  null
  
)

export default component.exports